import {
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
  Description as DocumentIcon,
  VideoLibrary as VideoIcon,
  AudioFile as AudioIcon,
  Archive as ArchiveIcon,
} from '@mui/icons-material';

// Helper to get file icon based on type
export const getFileIcon = (filetype, size) => {
  const fontSize = size || 'inherit';

  if (filetype.startsWith('image/')) return <ImageIcon sx={{ fontSize }} />;
  if (filetype === 'application/pdf') return <PdfIcon sx={{ fontSize }} />;
  if (filetype.startsWith('video/')) return <VideoIcon sx={{ fontSize }} />;
  if (filetype.startsWith('audio/')) return <AudioIcon sx={{ fontSize }} />;
  if (filetype.includes('zip') || filetype.includes('rar') || filetype.includes('7z')) {
    return <ArchiveIcon sx={{ fontSize }} />;
  }
  if (
    filetype.includes('document') ||
    filetype.includes('word') ||
    filetype.includes('text')
  ) {
    return <DocumentIcon sx={{ fontSize }} />;
  }
  return <FileIcon sx={{ fontSize }} />;
};